import { Scale } from "lucide-react";

const team = [
  {
    name: "Matthew Koenig",
    title: "Founder & CEO",
    initials: "MK",
    photo: "https://customer-assets.emergentagent.com/job_appellate-ai-pitch/artifacts/jj4e4t4g_mattkoenig-whitebg.jpg",
    bio: "Matthew Koenig has over 20 years of experience in the legal field. Matthew started his career with the NY County Clerk office, where he assisted practitioners, pro se parties, and judicial staff with complex filing procedures. While with the clerk\u2019s office, he spearheaded creation of the fully digitized NYSCEF filing system now used throughout New York State. Over the last decade, Matthew has been Managing Clerk for a top-5 ranked global law firm, where he routinely advises on compliance with complex litigation rules and procedures, with an expertise in the New York State court system.",
  },
  {
    name: "Boon Chew",
    title: "Founder & CTO",
    initials: "BC",
    photo: "https://customer-assets.emergentagent.com/job_appellate-ai-pitch/artifacts/u1vbq357_boon%20pic%20-%20white%20bg.png",
    bio: "Boon Chew is a venture builder and founder of Tappollo Media and Centaur Lab, focused on launching and scaling technology and AI companies. He has helped create platforms behind startups valued at over $3 billion and partnered with global brands including iHeartRadio, Discovery, CLEAR, and SEVENROOMS. His work spans high-growth consumer products and award-winning social impact platforms, including the first dating app for the autism community and Pepper, a social platform with over 2 million downloads.",
  },
  {
    name: "Michael Richter",
    title: "Founder & Advisor",
    initials: "MR",
    photo: "https://customer-assets.emergentagent.com/job_appellate-ai-pitch/artifacts/widcf2sw_Richter_Mike_web-300x300.jpg",
    bio: "Michael Richter is a litigation partner at FBT Gibbons and was previously a litigator at Skadden Arps. He has extensive experience leading complex, high-stakes disputes nationwide and has represented major public and private companies and their executives across a wide range of industries. Prior to private practice, Michael served as a U.S. intelligence officer and spearheaded creation of a major intelligence community program that was recognized by Harvard as one of the most innovative government programs in America.",
  },
];

export default function TeamSlide() {
  return (
    <div
      className="h-full w-full flex flex-col p-7 sm:p-10 lg:p-12"
      data-testid="slide-team-content"
    >
      <span className="text-sm font-bold tracking-[0.2em] uppercase text-blue-600 mb-2 font-body">
        THE TEAM
      </span>
      <h1 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-black tracking-tighter text-slate-900 mb-6 leading-tight">
        Experienced leadership across law, technology, and operations
      </h1>

      <div className="flex-1 flex flex-col md:flex-row gap-4 sm:gap-5 min-h-0">
        {team.map((person, i) => (
          <div
            key={i}
            className="flex-1 rounded-xl border border-slate-100 bg-white p-4 sm:p-5 flex flex-col"
          >
            <div className="flex items-center gap-3 mb-3">
              {person.photo ? (
                <img
                  src={person.photo}
                  alt={person.name}
                  className="w-10 h-10 rounded-full object-cover shrink-0"
                />
              ) : (
                <div className="w-10 h-10 rounded-full bg-blue-600 flex items-center justify-center shrink-0">
                  <span className="text-xs font-bold text-white font-heading">
                    {person.initials}
                  </span>
                </div>
              )}
              <div>
                <div className="text-sm font-bold text-slate-900 font-heading leading-tight">
                  {person.name}
                </div>
                <div className="text-sm font-semibold text-blue-600 font-body">
                  {person.title}
                </div>
              </div>
            </div>
            <p className="text-sm text-slate-600 font-body leading-relaxed flex-1">
              {person.bio}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
